<div class="draggable-list-container">
  <div cdkDropList (cdkDropListDropped)="drop($event)" class="draggable-list" [ngClass]="listClass">
    <div *ngFor="let item of displayedItems"
         cdkDrag
         [cdkDragData]="item"
         class="draggable-item"
         [ngClass]="[itemClass, isAddingThisItem(item) ? 'add-row' : '']"
         (cdkDragStarted)="onDragStarted($event)"
         (cdkDragMoved)="onDragMoved($event)"
         (cdkDragEnded)="onDragEnded($event)"
         [cdkDragDisabled]="isEditing(item) || isNewItem(item)">
      <div class="draggable-item-content">
        <div class="item-text">
          @if (isAddingThisItem(item)) {
            <mat-form-field appearance="fill" class="edit-field">
              <input matInput
                     [(ngModel)]="newItemValue"
                     (keydown)="onAddKeyDown($event)"
                     (click)="onAddInputClick($event)"
                     placeholder="Enter new item..."
                     #addInput>
            </mat-form-field>
          } @else if (isEditing(item)) {
            <mat-form-field appearance="fill" class="edit-field">
              <input matInput
                     [(ngModel)]="editingValue"
                     (keydown)="onKeyDown($event, item)"
                     (click)="onEditInputClick($event)"
                     #editInput>
            </mat-form-field>
          } @else {
            {{ getDisplayValue(item) }}
          }
        </div>
        <div class="item-actions">
          @if (isAddingThisItem(item)) {
            <mat-icon
              class="action-icon save-icon"
              (click)="saveAdd()"
              [class.disabled]="!newItemValue.trim()">
              check
            </mat-icon>
            <mat-icon
              class="action-icon cancel-icon"
              (click)="cancelAdd()">
              close
            </mat-icon>
          } @else if (isEditing(item)) {
            <mat-icon
              class="action-icon save-icon"
              (click)="saveEdit(item)"
              [class.disabled]="!editingValue.trim()">
              check
            </mat-icon>
            <mat-icon
              class="action-icon cancel-icon"
              (click)="cancelEdit()">
              close
            </mat-icon>
          } @else {
            <mat-icon
              *ngIf="showEdit"
              class="action-icon edit-icon"
              (click)="onEditClick(item)">
              edit
            </mat-icon>
            <mat-icon
              *ngIf="showDelete"
              class="action-icon delete-icon"
              [class.disabled]="isDeleteProtected(item)"
              [matTooltip]="protectedDeleteTooltip"
              [matTooltipDisabled]="!isDeleteProtected(item)"
              (click)="onDeleteClick(item)">
              delete
            </mat-icon>
          }
        </div>
      </div>

      <!-- Custom drag preview template -->
      <div *cdkDragPreview class="custom-drag-preview">
        <div class="drag-preview-content">
          <span>{{ getDisplayValue(item) }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
